import React from "react";

export default function ConfirmRunModal({ period, onConfirm, onCancel, busy }) {
  return (
    <div className="bfr-modal-backdrop" onClick={onCancel}>
      <div className="bfr-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Start a new export run?</h3>
        <p>
          This will read the NMP tab of the Google Sheet, generate PDFs for every store,
          and upload them to the configured Drive folder. Stores that already have a PDF
          for the period will be skipped.
        </p>
        <p>
          <strong>Period:</strong> {period.month_name} {period.year}
        </p>
        <div className="bfr-modal-actions">
          <button className="bfr-modal-cancel" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button className="bfr-run-button" onClick={onConfirm} disabled={busy}>
            {busy ? "Starting..." : "Yes, start run"}
          </button>
        </div>
      </div>
    </div>
  );
}
